import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as base64_decode, encode as base64_encode } from 'base-64';

const getSession = () => {
  const usersRt = sessionStorage.getItem('ddesp');
  return usersRt !== null ? JSON.parse(base64_decode(usersRt)) : null;
};

const normalizeResponse = (value) => {
  if (typeof value !== 'string') return value;
  const trimmed = value.trim();
  if (trimmed.startsWith('"') && trimmed.endsWith('"')) {
    return JSON.parse(trimmed);
  }
  return trimmed;
};

const ajaxConsultasAutomaticasEvent = ({ ll, dataPost, rejectMessage }) => {
  const users = getSession();
  const emp = users?.[0];
  const uid = users?.[3];
  const usuarioTipo = users?.[7];
  const token = users?.[14];

  return new Promise(function (resolve, reject) {
    try {
      // usuarioTipo (3 = dono/master da conta) — mesmo padrão de services/usuarios/index-f.js
      // e services/relatorios/index-f.js, que também mandam users[7]/storage[7] pro backend.
      const dd = [
        base64_encode(emp),
        base64_encode(uid),
        base64_encode(JSON.stringify({...(dataPost || {}), usuarioTipo})),
      ];

      $.ajax({
        url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
        type: 'GET',
        dataType: 'text',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: {
          pp: base64_encode('consultasAutomaticas'),
          ll: base64_encode(ll),
          dd: base64_encode(JSON.stringify(dd)),
        },
        success: function (data) {
          try {
            const responseData = normalizeResponse(data);

            if (responseData === 'erro_auth' || responseData === 'sessao_expirada') {
              sessionStorage.clear();
              window.location.href = '/auth/login';
              return;
            }

            const decoded = JSON.parse(base64_decode(responseData));
            resolve([200, decoded]);
          } catch (decodeError) {
            console.error('consultasAutomaticas:response decode error', { ll, data, decodeError });
            reject([400, { message: 'Resposta inválida do servidor' }]);
          }
        },
        error: function (xhr, status, error) {
          console.error('Erro AJAX consultasAutomaticas:', { ll, xhr, status, error });
          reject([400, { message: rejectMessage }]);
        },
      });
    } catch (err) {
      reject([500, { message: 'Server Error' }]);
    }
  });
};

/**
 * RestConsultasAutomaticasGet
 *
 * Destinos:
 * - verificarAcesso: { ehDono, tipos: { nfe, cte, nfse } } — se o usuário é o dono da conta
 *   e quais tipos de consulta automática estão ativos.
 * - filaResumo: { tipo } → cards de resumo da fila do tipo (nfe|cte|nfse).
 * - filaLista: { tipo, pagina } → lista paginada da fila do tipo, uma linha por CNPJ.
 * - historicoResumo: { tipo, janela } → disponibilidade agregada (todos os CNPJs) do tipo:
 *   tira de 90 dias + % na janela escolhida (6h|24h|7d|30d). Fonte: consulta_log.
 * - historicoCnpj: { tipo, cnpj, janela } → disponibilidade de um CNPJ: tira, % e interrupções.
 * - historicoDia: { tipo, dia, cnpj? } → consultas individuais de um dia da tira (clique num
 *   quadrado); agregado (todos os CNPJs) sem 'cnpj', ou só de um CNPJ quando informado.
 * - sefazStatus: { janela } → status GLOBAL de cada serviço da SEFAZ (não filtrado por conta):
 *   estado atual, % disponibilidade e tira de 90 dias por serviço. Fonte: monitor_sefaz.pings.
 * - sefazIncidentes: { janela, servico? } → interrupções dos serviços da SEFAZ no período.
 * - sefazDia: { servico, dia } → checagens individuais de um dia da tira de um serviço.
 */
export const RestConsultasAutomaticasGet = (config) => {
  const { dest, ...params } = config.params || {};
  const acao = (dest || '').trim();

  const mensagensErro = {
    verificarAcesso: 'Erro ao verificar acesso ao painel',
    filaResumo: 'Erro ao carregar resumo da fila de consulta automática',
    filaLista: 'Erro ao carregar a fila de consulta automática',
    historicoResumo: 'Erro ao carregar o histórico de disponibilidade',
    historicoCnpj: 'Erro ao carregar o histórico do CNPJ',
    historicoDia: 'Erro ao carregar o detalhe do dia',
    sefazStatus: 'Erro ao carregar o status da SEFAZ',
    sefazIncidentes: 'Erro ao carregar as interrupções da SEFAZ',
    sefazDia: 'Erro ao carregar o detalhe do dia',
  };

  if (!(acao in mensagensErro)) {
    return Promise.reject([400, { message: 'Destino inválido' }]);
  }

  return ajaxConsultasAutomaticasEvent({
    ll: acao,
    dataPost: params,
    rejectMessage: mensagensErro[acao],
  });
};
